import { FAQ_INFO_ELEMENTS, FAQ_CONTENT_INFO_ELEMENTS } from '../../models/FAQInfoSection';

class FAQInfoSectionSerializer {
  static deSerializeContent(contentItem, index) {
    switch (contentItem.type) {
      case FAQ_CONTENT_INFO_ELEMENTS.text:
        return {
          id: index,
          type: contentItem.type,
          content: contentItem.content,
        };
      case FAQ_CONTENT_INFO_ELEMENTS.link:
        return {
          id: index,
          type: contentItem.type,
          route: contentItem.route,
          content: contentItem.content,
        };
      default:
        return null;
    }
  }

  static deSerializeSectionItem(item, index) {
    switch (item.type) {
      case FAQ_INFO_ELEMENTS.body:
        return {
          id: index,
          type: item.type,
          content: item.content.map(FAQInfoSectionSerializer.deSerializeContent),
        };
      default:
        return null;
    }
  }

  static deSerialize(data) {
    return {
      title: data.title,
      items: data.items.map(FAQInfoSectionSerializer.deSerializeSectionItem),
    };
  }
}

export { FAQInfoSectionSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/FAQInfoSectionSerializer.js